import { FC } from 'react';
import ProblemTypeHierarchicalDisplay from '../../problem_type_hierarchical_display/ProblemTypeHierarchicalDisplay';
import OWTag from '../../common/OWTag';

// See TSLocationsDisplay for the wire contract on `*Ids` props.
// `ProblemTypeHierarchicalDisplay` already renders "All Problem Types" for an empty ids array, so
// here we only intercept the missing-key case.
const TSProblemTypesDisplay: FC<any> = ({
	problemTypes = [],
	problemTypeIds: rawProblemTypeIds,
}) => {
	const isNoneConfigured = rawProblemTypeIds === undefined || rawProblemTypeIds === null;
	if (isNoneConfigured) {
		return (
			<div className="flex flex-row flex-wrap items-center gap-2">
				<OWTag>{'No Problem Types'}</OWTag>
			</div>
		);
	}
	const hydratedProblemTypeIds = problemTypes.map((pt) => pt.id);
	return (
		<ProblemTypeHierarchicalDisplay problemTypeIds={hydratedProblemTypeIds} displayMode="pill" />
	);
};

export default TSProblemTypesDisplay;
